import { useForm, useController } from "react-hook-form";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";

import { CommonModal } from "../../../AbstractElements";
import CustomSelect from "../../../CommonElements/CustomSelect";

import { cancelVendorBooking } from "../../../Services/Ventor.service";
import { showAlert } from "../../../Services/Shared.service";
import { cancelTrip } from "../../../Services/Booking.service";

const VendorCancelBooking = (props) => {
  const reasonData = props?.reasonData ? props.reasonData : [];
  const bookingData = props.bookingData;
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const reasonField = useController({ name: "reason", control }).field;

  const handleReasonSelect = (data) => {
    reasonField.onChange(data.value);
  };

  const onReasonSubmit = (formValues) => {
    const obj = {
      aggregatorId: localStorage.getItem("aggregatorId"),
      bookingDTO: {
        megaCabsBookingNo: bookingData.megaCabsBookingNo,
      },
    };

    if (formValues.detailed_reason)
      obj.bookingDTO["detailedReason"] = formValues.detailed_reason;

    props.setShowApiLoader(true);

    if (props?.bookingData?.currentBookingStatusType !== "VendorAssigned") {
      const obj = {
        cancelReasonId: formValues.reason.id,
        megaCabsBookingNo: bookingData.megaCabsBookingNo,
        cancelReasonCode: formValues.reason.reasonCode,
        reason: formValues.reason.reason
      };
      
      cancelTrip(obj).then(result => {
        props.setShowApiLoader(false);
        showAlert('success', 'Booking Cancelled Successfully');
        props.onSubmitData.fetchBookingData().then(result => {
          reset()
          props.LargeModaltoggle()
        })
      }).catch(err => {
        props.setShowApiLoader(false);
        showAlert('error', 'Something went wrong');
      })
    }
    else {
      cancelVendorBooking(obj)
        .then((result) => {
          props.setShowApiLoader(false);
          showAlert("success", "Booking Cancelled Successfully");
          props.onSubmitData.fetchBookingData().then((result) => {
            reset();
            props.LargeModaltoggle();
          });
        })
        .catch((err) => {
          props.setShowApiLoader(false);

          console.log(err.response.data, "cancel booking value is")
          showAlert("error", err.response.data.message ? err.response.data.message : err?.response?.data ? err.response?.data : "Something went wrong");
        });
    }
  };

  return (
    <CommonModal
      isOpen={props.Large}
      title={props.title}
      toggler={() => {
        reset();
        props.LargeModaltoggle();
      }}
      size="md"
    >
      <Row className="cancel-booking">
        <Form onSubmit={handleSubmit(onReasonSubmit)}>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-12 col-form-label">Reason</Label>
            <Col lg="12">
              <CustomSelect
                className="service-select"
                classNamePrefix="select"
                isClearable={false}
                isSearchable={true}
                value={reasonData.find((element) => {
                  return element?.value?.id === reasonField?.value?.id;
                })}
                onChange={handleReasonSelect}
                placeholder="Select Reason"
                options={reasonData}
              />
            </Col>
          </FormGroup>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-12 col-form-label">Detailed Reason</Label>
            <Col lg="12">
              <textarea
                className="form-control"
                {...register("detailed_reason", {
                  required: {
                    value: false,
                  },
                })}
                type="text"
              />
            </Col>
          </FormGroup>
          <Row className="submit-booking">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={reasonField.value?.reason ? false : true}
            >
              Submit
            </button>
          </Row>
        </Form>
      </Row>
    </CommonModal>
  );
};

export default VendorCancelBooking;
